module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "private-office.81c04e3b.svg";